module.exports = __webpack_public_path__ + "img/餐费发票示例.a581ecc5.png";